import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const TermsAndConditions = () => {

  return (
    <div className="min-h-screen bg-gray-950 text-white font-sans">
      {/* Header Notice */}
      <div className="bg-gray-900 border-b border-gray-800 px-6 py-2 text-xs text-gray-300 flex items-center justify-between">
        <p>
          Important: All accounts are demo accounts with simulated funds. Trading occurs in a simulated environment.
        </p>
      </div>

      {/* Navigation */}
      <nav className="border-b border-gray-800 px-8" style={{ backgroundColor: '#101925' }}>
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img src="/logo-bgremoved.png" alt="NEXXO FUNDED" className="h-16 brightness-110 contrast-110 saturate-110 hover:brightness-125 transition-all duration-300 rounded-lg" />
          </div>
          <Link 
            to="/"
            className="flex items-center gap-2 px-4 py-2 text-gray-400 hover:text-white transition-colors"
          >
            <ArrowLeft size={16} />
            Back
          </Link>
        </div>
      </nav>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-6 py-12">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold mb-4 bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent">
            General Terms and Conditions
          </h1>
        </div>

        {/* Content - Provided text with brand and email updates, no design changes */}
        <div className="prose prose-invert max-w-none">
          <div className="text-gray-300 leading-8 text-[15px] md:text-base break-words space-y-4">
            {`
These Nexxo General Terms and Conditions (the “GTC”) govern rights and obligations in connection with the use of services provided by Nexxo Global Limited as described below (the “Services”), offered mainly through the http://nexxofunded.com/ website (the “Website”). Please read these GTC carefully. You are under no obligation to use the Services if you do not agree or understand any portion of these Terms, nor should you use the Services unless you understand and agree to these Terms. 

1. INTRODUCTORY PROVISIONS 

1.1. These GTC govern your (“You”, “Your”, or the “Customer”) rights and obligations in connection with the use of the Services provided by Nexxo Global Limited, with its registered office at Unit 1 74 Back Church Lane, London, E1 1LX UK, company no.: 14451720 (“We”, “Our”, or the “Provider”). 

1.2. By registering on the Website or, where registration is not required, not later 
than by your first use of the Services, you are entering into a contract with 
the Provider, the subject of which is the provision of the Services of your 
choice. The GTC form an integral part of such a contract and, by executing 
the contract with the Provider, you express your agreement to these GTC.

1.3. The Services are only intended for persons over the age of 18 residing in the 
country for which the Services are available. By registering on the Website, 
you confirm that you are over 18 years of age. If you are under 18 years of 
age, you may not use the Services. You undertake to access the Services 
solely from one of the countries for which the Services are available. You 
acknowledge that your access to and use of the Services may be restricted or 
prohibited by law in some countries, and you undertake to only access and 
use the Services in accordance with applicable laws.


1.4. The Provider shall not provide Services to Customer that: (i) is of nationality 
or is residing in Restricted Jurisdictions; (ii) is established or incorporated or 
has a registered office in Restricted Jurisdictions; (iii) is subject to the 
relevant international sanctions; or (iv) has a criminal record related to 
financial crime or terrorism. Restricted Jurisdictions means countries 
determined as such by the Provider and published on the Website or in the 
framework of these GTC. The Provider reserves the right to refuse, restrict 
or terminate the provision of any Services to Customer as per this Clause

1.4.1. and such Customer is prohibited to use the Services, which also includes the 
use of the Client Account and/or Platform.  


1.5. The Services consist of the provision of tools for SIMULATED foreign 
exchange trading on the FOREX market or SIMULATED trading with other 
instruments on other financial markets, provision of analytical tools, training 
and educational materials, the access to the Client Account, and other 
ancillary services, in particular through the Client Account or by the 
provision of access to applications provided by the Provider or third parties. 
Financial market information is used in the simulated trading; however, you 
acknowledge 
that any trading that you perform through the Services is not real. You also 
acknowledge that the funds provided to you for demo trading are fictitious 
and that you have no right to possess those fictitious funds beyond the scope 
of their use within the Services, and in particular that they may not be used 
for any actual trading and that you are not entitled to the payment of those 
funds. Unless expressly agreed otherwise, you will not be paid any 
remuneration or profits based on the results of your simulated trading, nor 
will you be required to pay any losses. 


1.6. NONE OF THE SERVICES PROVIDED TO YOU BY THE PROVIDER 
CAN BE CONSIDERED INVESTMENT SERVICES IN ACCORDANCE 
WITH APPLICABLE LAWS. THE PROVIDER DOES NOT GIVE OR 
PROVIDE TO YOU ANY GUIDANCE, INSTRUCTIONS, OR 
INFORMATION ABOUT HOW OR IN WHICH MANNER YOU 
SHOULD PERFORM TRANSACTIONS WHEN USING THE SERVICES 
OR OTHERWISE, OR ANY OTHER SIMILAR INFORMATION ABOUT 
THE INVESTMENT TOOLS TRADED, NOR DOES THE PROVIDER 
ACCEPT ANY SUCH GUIDANCE, INSTRUCTIONS, OR 
INFORMATION FROM YOU.NONE OF THE SERVICES 
CONSTITUTE INVESTMENT ADVICE OR RECOMMENDATIONS. 
NO EMPLOYEES, STAFF, OR REPRESENTATIVES OF THE 
PROVIDER ARE AUTHORIZED TO PROVIDE INVESTMENT 
ADVICE OR RECOMMENDATIONS. SHOULD ANY INFORMATION 
OR 
STATEMENT OF ANY EMPLOYEE, STAFF, OR 
REPRESENTATIVES OF THE PROVIDER BE INTERPRETED AS 
INVESTMENT ADVICE OR RECOMMENDATIONS, THE PROVIDER 
EXPLICITLY DISCLAIMS THAT THE SAME IS INVESTMENT 
ADVICE OR RECOMMENDATIONS AND SHALL NOT BE 
RESPONSIBLE FOR THEM. 

1.7. Your personal data is processed in accordance with the Privacy Policy. 

1.8. The meaning of the definitions, expressions, and abbreviations used in these 
GTC can be found in clause 18. 

2. SERVICES AND THEIR ORDER 


2.1. You can order the Services through the Website by completing the 
appropriate registration or order form. After registration, We will e-mail you 
the login details for the Client Account and/or Platform and allow you to 
access them (“Welcome E-mail"). 

2.2. The Services include, among other things, the Free Monthly Trading 
Contests, Nexxo Challenge, and Verification products; these products may 
differ in the scope of the Services provided (e.g., by analytical tools available 
to the Customer). With the Free Monthly Trading Contests, you may use 
some of the Services within a limited scope and for a limited period free of 
charge. Completing the Free Monthly Trading Contests does not entitle you 
to access any other Services. 

2.3. All data that you provide to us through the registration or order form, the 
Client Account, or otherwise must be complete, true, and up to date. You 
must immediately notify us of any change in your data or update the data in 
your Client Account. The Customer is responsible for all the provided data 
being accurate and up to date; the Provider is not obligated to verify the data.

2.4. You acknowledge that if you provide an identification number, tax 
registration number or other similar information in the registration or order 
form or in the Client Account, or if you state that you are a legal entity, you 
will be considered as an entrepreneur (trader) for the purposes of these GTC 
and when using the Services, and the provisions of these GTC or the 
applicable law that grant rights to consumers will not apply to you.

2.5. The fee for the Nexxo Challenge varies according to the option selected and 
depends on the amount of the Account Balance, the degree of the acceptable 
risk, the parameters that must be fulfilled so that the conditions of the Nexxo 
Challenge and the subsequent Verification are met, and possibly other 
configurations. More detailed information on individual options and fees for 
those options are provided on Our Website. The final fee will be determined 
based on the option you select when completing the form for
ordering the Nexxo Challenge. The Provider reserves the right to also 
provide the Services under individually agreed conditions. All individually 
agreed conditions shall be determined by the Provider at its own discretion. 
Individual discounts and other benefits may not be combined, unless 
expressly stipulated otherwise by the Provider.  


2.6. The fee is paid for allowing you to access the Nexxo Challenge, or the 
Services provided under the Nexxo Challenge. The Customer is not entitled 
to a refund of the fee, for example, if the Customer cancels the Customer’s 
Client Account or requests the cancellation by e-mail, if the Customer 
terminates the use of the Services or the contract (for example, fails to 
complete the Nexxo Challenge or the Verification), fails to meet the 
conditions of the Nexxo Challenge or the Verification, or violates these 
GTC. 

2.7. If the Customer lodges an unjustifiable complaint regarding the paid fee or 
disputes the paid fee with the Customer’s bank or payment service provider 
(e.g. through chargeback services, dispute services, or other similar services), 
on the basis of which an annulment, cancellation or refund of the fee or any 
part thereof is requested, the Provider is entitled, at its own discretion, to stop 
providing to the Customer any services and refuse any future provision of 
any services.

2.8. Your choice of the option of the Nexxo Challenge that you select when 
making an order shall also apply to the subsequent Verification. You will 
start the subsequent Verification and, possibly, other products related thereto, 
with the parameters and the same currency that correspond to the option of 
the Nexxo Challenge selected by you. Once you make a selection, it is not 
possible to change it. If you are ordering a new Nexxo Challenge, the 
restrictions specified in this clause 2.8 shall not apply. 

2.9. The Provider reserves the right to unilaterally change the fees and parameters 
of the Services at any time. The change does not affect the Services 
purchased before the change is notified. 

2.10. 
Any data entered in the order form can be checked, corrected, and 
amended until the binding order of the Services. The order of the Services of 
your choice is made by choosing the applicable for you phase on the Website. 
The Provider will immediately confirm the receipt of your order 
to your e-mail address. In the case of the Free Monthly Trading Contests, the 
order is completed upon the delivery of the confirmation to your e-mail
address, whereby the contract is executed. In the case of the Nexxo 
Challenge, the order is completed upon the payment of the fee for the selected 
option, whereby the contract between you and the Provider is executed, the 
subject of which is the provision of the Nexxo Challenge and, if the 
conditions of the Nexxo Challenge are met, and the Verification. The 
contract is concluded in English. We archive the contract in electronic form 
and do not allow access to it. 

2.11. 
You acknowledge that in order to use Our Services, you must obtain 
the appropriate technical equipment and software, including third-party 
software (e.g., software for the use of the Platform), at your own risk and 
expense. The Website is accessible from the most commonly used web 
browsers. The internet access, purchase of the equipment, and purchase of 
the web browser and its updates are at your own risk and expense. The 
Provider does not warrant or guarantee that the Services will be compatible 
with any specific equipment or software. The Provider does not charge any 
additional fees for the internet connection. 

2.12. 
You acknowledge that the operators of Platforms are persons or entities 
different from the Provider and that their own terms and conditions and 
privacy policies will apply when you use their services and products. Before 
sending an order form, you are obligated to read those terms and conditions 
and privacy policies. 

2.13. 
If the Customer places an unusually large number of orders for the 
Services within an unreasonably short period of time, the Provider may notify 
the Customer through the Client Account as a protective precaution to 
mitigate potentially harmful behaviour of the Customer. If such unreasonable 
behaviour continuous after such notice, We reserve the right to suspend any 
further orders of the Services by the Customer. If We identify that the unusual 
behaviour as per this paragraph relates to the Customer’s involvement in 
Forbidden Trading Practices, We may take respective actions as perceived in 
Section 5 of this GTC. The Provider reserves the right to determine, at its 
own discretion, the nature of the behaviour described above and reasonable 
boundaries for such determination. 

2.14. 
All references to Nexxo’s hours of trading are in the United Kingdom. 
GMT using a 12-hour format. Nexxo reserves the right to suspend or modify 
its trading hours at any time and in such an event will inform its Customers
in advance on a best-efforts basis of any changes in its operating hours. 
trading hours by a written notification. 


3. PAYMENT TERMS 

3.1. The amounts of fees for the Nexxo Challenge options are in USD. The fee 
can also be paid in other currencies that are listed on the Website. If you 
select any other currency than the USD, the amount of the fee for the selected 
option of the Nexxo Challenge shall be converted by Our rates and it will 
automatically display your payment total in your chosen currency, so you 
know how much you are paying before you confirm the order. The Customer 
acknowledges that if the payment is made in a currency other than the one 
the Customer has chosen on the Website, the amount will be converted 
according to the current exchange rates valid at the time of payment.

3.2. Service charges are inclusive of all taxes. If the Customer is an entrepreneur 
(trader), he is obliged to fulfil all his tax obligations in connection with the 
use of Our Services in accordance with applicable law, and in the event of an 
obligation, he is obliged to pay tax or other fees properly. 

3.3. You can pay the fee for the selected option of the Nexxo Challenge by a 
payment card or using other means of payment that the Provider currently 
offers on the Website. 

4. CLIENT ACCOUNT AND PLATFORM 

4.1. Only one Client Account is permitted per Customer and all of the Customer’s 
Services must be maintained in the Client Account. 

4.2. Client Account Unless the Provider grants an exception to the Customer, the 
Account Balance amounts may not be transferred between the individual 
products or mutually combined. You may also not transfer or combine your 
performance, Service parameters, data, or any other information between the 
products. 

4.3. Access to the Client Account and Platform is protected by login data, which 
the Customer may not make available or share with any third party. If the 
Customer has registered as a legal entity, the Customer may allow the use of 
the Services through the Customer’s Client Account to the authorized 
employees and representatives. The Customer is responsible for all activities that are 
performed through the Customer’s Client Account 
or Platform. The Provider bears no responsibility, and the Customer is not 
entitled to any compensation, for any misuse of the Client Account, Platform, 
or any part of the Services, nor is the Provider responsible for any negative 
consequences thereof for the Customer, if such misuse occurs for any reasons 
on the part of the Customer.

4.4. The Customer acknowledges that the Services may not be available around 
the clock, particularly with respect to maintenance, upgrades, or any other 
reasons. In particular, the Provider bears no responsibility, and the Customer 
is not entitled to any compensation, for the unavailability of the Client 
Account or Platform and for damage or loss of any data or other content that 
Customer uploads, transfers or saves through the Client Section or Platform.


4.5. With respect to clause 5.4.1.6 below, the Provider may decrease leverage 
levels during the Events as defined below, from the standard leverage ratio 
to 10:1 for FX and Metals starting 10 minutes before the Events and ending 
5 minutes after the Events announcement (“Reduced Leverage Window”). 
Notwithstanding the above, positions which were opened prior to the 
Reduced Leverage Window shall be affected by the reduced leverage. The 
Provider may in its sole discretion to lower the leverage ratios for certain 
periods of time for any kind of Events and only the ones which fall under the 
definition of Events as defined below, in such instances, the Customer shall 
receive a notification at least 24 hours in advance (e.g., during elections or 
unforeseen circumstances). 


4.6. The Customer may at any time request the cancellation of the Client Account 
by sending an e-mail to support@nexxofunded.com. Sending a request for the 
cancellation of the Client Section is considered as a request for termination 
of the contract by the Customer, with the Customer being no longer entitled 
to use the Services, including the Client Account and Platform. The Provider 
will immediately confirm the receipt of the request to the Customer by e
mail, whereby the contractual relationship between the Customer and the 
Provider will be terminated. In such a case, the Customer is not entitled to 
any refund of the fees already paid or costs otherwise incurred. 


5. RULES OF DEMO TRADING 


5.1. During the demo trading on the Platform, you may perform any transactions, 
unless these constitute forbidden trading strategies or practices within the 
meaning of clause 5.4. You also agree to follow good market standard rules
and practices for trading on financial markets (e.g., risk management rules). 
Restrictions may also be imposed by the trading conditions of the Platform 
that you have selected for trading. 


5.2. You acknowledge that the Provider has access to information about the demo 
trades that you perform on the Platform. You grant the Provider your consent 
to share this information with persons/entities who are in a group with the 
Provider or who are otherwise affiliated with the Provider, and you grant the 
Provider and these persons/entities your consent and authorization to handle 
this information at their own will. You agree that these activities may be 
performed automatically without any further consent, consultation, or 
approval on your part being necessary, and that you are not 
entitled to any remuneration or revenue associated with the use of the data 
by the Provider. The Provider is aware that you do not provide the Provider 
with any investment advice or recommendations through your demo trading. 
You acknowledge that you may suspend your demo trading on the Platform 
at any time. 


5.3. The Provider bears no responsibility for the information displayed on the 
Platform, nor for any interruption of, or delay or inaccuracy in the market 
information displayed through your Client Account. 

5.4. FORBIDDEN TRADING PRACTICES.

5.4.1. DURING THE DEMO TRADING, IT IS PROHIBITED TO: 

5.4.1.1. KNOWINGLY OR UNKNOWINGLY USE TRADING 
STRATEGIES THAT EXPLOIT ERRORS IN THE SERVICES 
SUCH AS ERRORS IN DISPLAY OF PRICES OR DELAY IN 
THEIR UPDATE; 

5.4.1.2. PERFORM TRADES USING AN EXTERNAL OR SLOW 
DATA FEED;  

5.4.1.3. PERFORM TRADES WHICH UNDER THE SOLE 
DISCRETION OF THE COMPANY ARE INVOLVE HIGHLY 
SPECULATIVE TRADING STRATEGIES, INVOLVING 
EXCESSIVE RISK-TAKING BEYOND THE NORMS 
OBSERVED IN STANDARD TRADING PRACTICES.

5.4.1.4. PERFORM, ALONE OR IN CONCERT WITH ANY OTHER 
PERSONS, 
INCLUDING 
BETWEEN CONNECTED 
ACCOUNTS, OR ACCOUNTS HELD WITH DIFFERENT 
Nexxo ENTITIES, TRADES OR COMBINATIONS OF TRADES 
THE PURPOSE OF WHICH IS TO MANIPULATE TRADING, 
FOR EXAMPLE BY SIMULTANEOUSLY ENTERING INTO 
OPPOSITE POSITIONS; 

5.4.1.5. PERFORM TRADES IN CONTRADICTION WITH THE 
TERMS AND CONDITIONS OF THE PROVIDER AND THE 
PLATFORM; 
(e) USE ANY SOFTWARE, ARTIFICIAL INTELLIGENCE, 
ULTRA-HIGH SPEED, OR MASS DATA ENTRY WHICH 
MIGHT MANIPULATE, ABUSE, OR GIVE YOU AN UNFAIR 
ADVANTAGE WHEN USING OUR SYSTEMS OR 
SERVICES; 

5.4.1.6. PERFORM GAP TRADING BY OPENING TRADE(S):  
(I) 
WHEN MAJOR GLOBAL NEWS, MACROECONOMIC 
EVENT OR CORPORATE REPORTS OR EARNINGS 
(“EVENTS”), THAT MIGHT AFFECT THE RELEVANT 
FINANCIAL MARKET (I.E. MARKET THAT ALLOWS 
TRADING OF FINANCIAL INSTRUMENTS THAT MIGHT 
BE AFFECTED BY THE EVENTS), ARE SCHEDULED; 
AND 
(II) 
2 HOURS OR LESS BEFORE A RELEVANT FINANCIAL 
MARKET IS CLOSED FOR 2 HOURS OR LONGER; OR

5.4.1.7. OTHERWISE PERFORM TRADES IN CONTRADICTION 
WITH HOW TRADING IS ACTUALLY PERFORMED IN THE 
FOREX MARKET OR IN ANY OTHER FINANCIAL MARKET, 
OR IN A WAY THAT ESTABLISHES JUSTIFIED CONCERNS 
THAT THE PROVIDER MIGHT SUFFER FINANCIAL OR 
OTHER HARM AS A RESULT OF THE CUSTOMER’S 
ACTIVITIES (E.G. OVERLEVERAGING, OVEREXPOSURE, 
ONE-SIDED BETS, ACCOUNT ROLLING, STATISTICAL 
ARBITRAGE). 

5.4.1.8. PERFORM ANY TRADING WHICH IS SEEN AS 
PROHIBITED AS PER THE SOLE DISCRETION OF Nexxo, 
THE UPDATED LIST OF PROHIBITED TRADING CAN BE 
FOUND HERE. Nexxo MY ALTER AND AMEND THE OF 
PROHIBITED LIST OF TRADING AT ANY TIME WITH A 
NOTICE OF 7 DAYS.   
5.4.2. As Our customer, you should understand and agree that all Our 
Services are for Customer’s personal use only, meaning that only you 
personally can access your Nexxo Challenge and Verification accounts 
and perform trades. For that reason, you should not, and you agree not 
to, 
(a) allow access to and trading on your Nexxo Challenge and 
Verification accounts by any third party nor you shall engage or 
cooperate with any third party in order to have such third party perform 
trades for you, whether such third party is a private person or a 
professional; (b) access any third-party Nexxo Challenge and 
Verification accounts, trade on behalf of any third party or perform any 
account management or similar services, where you agree to trade, 
operate or manage the Nexxo Challenge and Verification accounts on 
behalf of another user, all whether performed as a professional or 
otherwise. Please note that if you act or behave in contradiction with the 
aforesaid, We will consider such action/behaviour as a Forbidden 
Trading Practice under Section 5.4. with respective consequences as 
perceived under this GTC. 


5.4.3. Furthermore, Customer shall not exploit the Services by performing 
trades without applying market standard risk management rules for 
trading on financial markets, this includes, among others, the following 
practices (i) opening substantially larger position sizes compared to 
Customer’s other trades, whether on this or any other Customer’s 
account, or (ii) opening substantially smaller or larger number of 
positions compared to Customer’s other trades, whether on this or any 
other Customer’s account. The Provider reserves the right to determine, 
at 
its 
own 
discretion, 
whether 
trades, 
practices, strategies, or situations are Forbidden Trading Practices. 
certain 

5.5. If the Customer engages in any of the Forbidden Trading Practices described 
in clause 5.4, (i) the Provider may consider it as a failure to meet the 
conditions of the particular Nexxo Challenge or Verification, (ii) the 
Provider 
may 
remove 
the 
transactions 
that 
violate 
the prohibition from the Customer’s trading history and/or not count their 
results in the profits and/or losses achieved by the demo trading, (iii) the 
Provider may restrict the Customer’s account in terms of leverage for  
indefinite period of time, or (iiii) to immediately cancel all Services provided 
to the Customer and subsequently terminate this contract. 

5.6. In case when some or all Forbidden Trading Practices are executed on one or 
more Nexxo Challenge and Verification accounts of one Customer, or 
accounts of various Customers, or by combining trading through Nexxo 
Challenge and Verification accounts and Nexxo Trader accounts, then the 
Provider is entitled to cancel all Services and terminate all 
respective contracts related to any and all Customer’s Nexxo Challenge and 
Verification accounts and/or apply other measures in Clause 5.5. The 
Provider may exercise any and all actions in Clauses 5.5 and 5.6 at its own 
discretion.

5.7. If any Nexxo Trader accounts were used for or were involved in the 
Forbidden Trading Practices, this may and will constitute a breach of 
respective terms and conditions for Nexxo Trader account with third-party 
provider 
and 
may 
result 
in 
cancellation 
of 
such 
user accounts and termination of respective agreements by the third-party 
provider. 
all 

5.8. If the Customer engages in any of the practices described in clause 5.4 
repeatedly, and the Provider has previously notified the Customer thereof, 
the Provider may prevent the Customer from accessing all Services or their 
parts, including access to the Client Section and Platform, without any 
compensation. In such a case, the Customer is not entitled to a refund of the 
fees paid. 

5.9. The Provider does not bear any responsibility for trading or other investment 
activities performed by the Customer outside the relationship with the 
Provider, for example by using data or other information from the Client 
Account, Platform, or otherwise related to the Services in real trading on 
financial markets, not even if the Customer uses for such trading the same 
Platform that the Customer uses for demo trading. 

5.10. 
In case the Customer engaged in any of the Forbidden Trading 
Practices as described in clause 5.4, and the Provider decided to cancel all 
Services provided to the Customer and subsequently terminate this contract 
as described in clause 5.5, and the Customer shall not have the right to dispute 
the termination of this contract. Moreover, any illegal action by the Customer 
such as but not limited to, threats of defamation against the Provider, may 
result in legal proceeding against the Customer.  

5.11. 
DEVELOPMENTS IN FINANCIAL MARKETS ARE SUBJECT TO 
FREQUENT AND ABRUPT CHANGES. TRADING ON FINANCIAL 
MARKETS MAY NOT BE PROFITABLE AND CAN LEAD TO 
SIGNIFICANT 
FINANCIAL 
LOSSES. 
ANY PREVIOUS 
PERFORMANCES AND PROFITS OF THE CUSTOMER’S DEMO 
TRADING ARE NOT A GUARANTEE OR INDICATION OF ANY 
FURTHER PERFORMANCE. 

6. Nexxo CHALLENGE AND VERIFICATION 

6.1. After paying the fee for the selected option of the Nexxo Challenge, the 
Customer will receive the relevant login data for the Platform at the e-mail 
address provided by the Customer or in the Client Account. The Customer 
activates the Nexxo Challenge by opening the first demo trade in the 
Platform. YOU ACKNOWLEDGE THAT, BY OPENING THE FIRST 
DEMO TRADE, YOU EXPRESSLY DEMAND THE PROVIDER 
TO PROVIDE COMPLETE SERVICES. IF YOU ARE A CONSUMER, IT 
MEANS THE COMPLETION OF SERVICES BEFORE THE EXPIRY OF 
THE PERIOD FOR WITHDRAWAL FROM THE CONTRACT, WHICH 
AFFECTS YOUR RIGHT TO WITHDRAW FROM THE CONTRACT, AS 
SPECIFIED IN MORE DETAIL IN CLAUSE 12. If you do not activate the 
Nexxo Challenge within 30 calendar days of the date on which it was made 
available to you, your access to it will be suspended. You can request the 
renewal of access via the Client Account or by sending an e-mail to 
support@nexxofunded.com within 6 months of the initial suspension, otherwise We 
will terminate the provision of the Services without any right to a refund of 
the fee.  

6.2. In order for the Customer to meet the conditions of the Nexxo Challenge, 
the Customer must fulfil all of the parameters as stipulated on the Website.

6.3. If the Customer has met the conditions of the Nexxo Challenge as stipulated 
on the Website, and at the same time has not violated these GTC, in particular 
the rules of demo trading under clause 5.4, the Provider will evaluate the 
Nexxo Challenge as successful and will make the Verification available to 
the Customer free of charge by sending login details to the Customer’s e
mail address or Client Account. The Provider does not have to evaluate the 
Nexxo Challenge if the Customer has not closed all trades. 

6.4. The Customer activates the Verification by opening the first demo trade in 
the Trading Platform. If the Customer does not activate the Verification 
within 30 calendar days from the day on which the Customer received the 
new login data, the Customer’s access to the Verification will be suspended. 
The Customer may request the renewal of access via the Client Account or 
by sending an e-mail to support@nexxofunded.com within 6 months of the 
suspension, otherwise We will terminate the provision of the Services 
without any right to a refund. 


6.5. In order for the Customer to meet the conditions of the Verification, the 
Customer must fulfil all of the parameters as stipulated on the Website . 
If the above conditions are met, the Provider will evaluate the Verification as 
successful and will recommend the Customer as a candidate for Nexxo 
Trader program. The Provider does not have to evaluate the Verification if 
the Customer has not closed all transactions. 

6.6. If during the Nexxo Challenge the Customer does not comply with some of 
the conditions specified in clause 6.2, the Nexxo Challenge will be evaluated 
as unsuccessful, and the Customer will not be allowed access to the 
subsequent Verification. If during the Verification the Customer does not 
comply 
with 
any 
of 
the 
conditions 
specified 
in 
clause 
6.5, the Verification will be evaluated as unsuccessful, and the Customer will 
not be recommended as a candidate for the Nexxo Trader program. In such 
cases, the Customer’s account and Services will be cancelled without refund 
of fees already paid. 

6.7. Provider recommending Customer as a candidate for the Nexxo Trader 
Program in no way guarantees Customer’s acceptance into the Nexxo Trader 
Program. The Provider is not responsible for Customer being rejected by the 
Nexxo Trader Program for any or no reason.

7. SOCIAL MEDIA & PUBLIC COMPLAINTS 

7.1. Customer should address any concerns or complaints directly with these 
GTC before posting any of them on social media or other public forums. If 
the Customer shall post a complaint and or any communication with Nexxo 
publicly, Nexxo reserve the right to take any appropriate legal action against 
the Customer regardless if the content is deemed defamatory, misleading, or 
in violation of Nexxo’s trademark rights. 

8. Nexxo TRADER 
If the Customer is successful in both the Challenge and Verification, the 
Customer may be offered a contract by a third-party company, in its sole 
discretion to participate in the Nexxo Trader Program. The terms, 
conditions, and agreement between the Customer and a third-party company 
are strictly between the Customer and the third-party company. Nexxo 
Global Limited is in no way involved with the Nexxo Trader 
Program agreement or lack thereof executed between the third-party 
company and the Customer. The Customer acknowledges their personal data 
may be shared with a third-party company for purposes of considering 
offering such a contract. 


9. USE OF THE WEBSITE, SERVICES AND OTHER CONTENT 

9.1. The Website and all Services, including the Client Account, their appearance 
and all applications, data, information, multimedia elements such as texts, 
drawings, graphics, design, icons, images, audio and video samples, and any 
other content that may form the Website and the Services (collectively as the 
“Content”), are subject to legal protection pursuant to copyright laws and 
other legal regulations and are the property of the Provider or the Provider’s 
licensors. The Provider grants you limited, non-exclusive, non-transferable, 
non-assignable, non-passable, and revocable permission to use the Content 
for the purpose of using the Services for your personal use and in accordance 
with the purpose for which the Services are provided. The Content is not sold 
or otherwise transferred to you and remains the property of the Provider or 
the Provider’s licensors. 

9.2. All trademarks, logos, trade names, and other designations are the property 
of the Provider or Provider’s licensors, and the Provider does not grant you 
any authorization to use them. 

9.3. Both the Customer and the Provider undertake to act in accordance with the 
principles of fair dealing in the performance of the contract and in mutual 
negotiations and, in particular, not to damage the good reputation and 
legitimate interests of the other party. The Customer and the Provider will 
resolve any possible disagreements or disputes between them in accordance 
with these GTC and the parties agree that the law of England and Wales will 
govern the performance and interpretation of their agreement and disputes 
arising under it. 

9.4. Any legal relations established by these GTC or related to them, as well as 
any related on-contractual legal relations, shall be governed by the laws of 
the Wales. Any dispute that may arise in connection with these GTC and/or 
related agreements will fall within the jurisdiction of the courts of London 
having local jurisdiction according to the registered office of the Provider.

9.5. Except for the rights expressly set out in these GTC, the Provider does not 
grant you any other rights relating to the Services and other Content. You 
may only use the Services and other Content as set out in these GTC. 

9.6. When accessing the Services and other Content, the following is prohibited: 

9.6.1. to use any tools that may adversely affect the operation of the 
Website and Services or that would be intended to take advantage of 
errors, bugs or other deficiencies of the Website and Services; 

9.6.2. to circumvent geographical restrictions of availability or any other 
technical restrictions; 

9.6.3. to make copies or back-ups of the Website and other Content; 

9.6.4. to reverse-engineer, decompile, disassemble or otherwise modify 
the Website and other Content; 

9.6.5. to sell, rent, lend, license, distribute, reproduce, spread, stream, 
broadcast or use the Services or other Content otherwise than 
as permitted;

9.6.6. to use automated means to view, display or collect information 
available through the Website or Services; and 

9.6.7. to use any other tools or means the use of which could cause 
any damage to the Provider. 

9.7. The provisions of clause 8 are not intended to deprive the Customer of the 
Customer’s consumer rights which cannot be excluded by law. 


10. DISCLAIMER

10.1. 
YOU ACKNOWLEDGE THAT THE SERVICES AND OTHER 
CONTENT ARE PROVIDED “AS IS” WITH ALL THEIR ERRORS, 
DEFECTS AND SHORTCOMINGS, AND THAT THEIR USE IS AT 
YOUR SOLE RESPONSIBILITY AND RISK. TO THE MAXIMUM 
EXTENT PERMITTED BY THE MANDATORY LAWS, THE 
PROVIDER DISCLAIMS ANY STATUTORY, CONTRACTUAL, 
EXPRESS, AND IMPLIED WARRANTIES OF ANY KIND, INCLUDING 
ANY WARRANTY OF QUALITY, MERCHANTABILITY, FITNESS 
FOR A PARTICULAR PURPOSE, OR NON-INFRINGEMENT OF ANY 
RIGHTS. 


10.2. 
TO THE EXTENT PERMITTED BY THE MANDATORY 
PROVISIONS OF THE APPLICABLE LAWS, THE PROVIDER IS NOT 
RESPONSIBLE FOR ANY HARM, INCLUDING ANY INDIRECT, 
INCIDENTAL, SPECIAL, PUNITIVE OR CONSEQUENTIAL 
DAMAGES, INCLUDING LOST PROFIT, LOSS OF DATA, PERSONAL 
OR OTHER NON-MONETARY HARM OR PROPERTY DAMAGE 
CAUSED AS A RESULT OF USE OF THE SERVICES OR RELIANCE 
ON ANY TOOL, FUNCTIONALITY, INFORMATION OR ANY OTHER 
CONTENT AVAILABLE IN CONNECTION WITH THE USE OF THE 
SERVICES OR ELSEWHERE ON THE WEBSITE. THE PROVIDER 
ISNOT RESPONSIBLE FOR ANY PRODUCTS, SERVICES, 
APPLICATIONS OR OTHER THIRD- PARTY CONTENT THAT THE 
CUSTOMER USES IN CONNECTION WITH THE SERVICES. IN CASE 
THE PROVIDER’S LIABILITY IS INFERRED IN CONNECTION WITH 
THE OPERATION OF THE WEBSITE OR PROVISION OF THE 
SERVICES BY A COURT OF JUSTICE OR ANY OTHER COMPETENT 
AUTHORITY, THIS LIABILITY SHALL BE LIMITED TO THE 
AMOUNT CORRESPONDING TO THE FEE PAID BY THE CUSTOMER 
FOR THE SERVICES IN CONNECTION WITH WHICH THE 
CUSTOMER HAS INCURRED THE LOSS. 


10.3. 
The Provider reserves the right to modify, change, replace, add, or 
remove any elements and functions of the Services at any time without any 
compensation. 

10.4. 
The Provider is not responsible for its failure to provide the purchased 
Services if that failure occurs due to serious technical or operational reasons 
beyond the Provider’s control, in the case of any crisis or imminent crisis, 
natural disaster, war, insurrection, pandemic, a threat to a large number of 
people or other force majeure events, and/or if the Provider is prevented from 
providing the Services as a result of any obligations imposed by law or a 
decision of a public authority. 
10.5. 
The provisions of Clause 9 are not intended to deprive the Customer of 
the Customer’s consumer or other rights that cannot be excluded by law. 

11. VIOLATION OF THE GTC 
IF THE CUSTOMER VIOLATES ANY PROVISION OF THESE GTC IN 
A MANNER THAT MAY CAUSE ANY HARM TO THE PROVIDER, IN 
PARTICULAR, IF THE CUSTOMER ACCESSES THE SERVICES IN 
CONFLICT WITH CLAUSE 1.3 OR 1.4, IF THE CUSTOMER PROVIDES 
INCOMPLETE, UNTRUE OR NON-UPDATED INFORMATION IN 
CONFLICT WITH CLAUSE 2.3, IF THE CUSTOMER ACTS IN A 
MANNER THAT MAY DAMAGE THE PROVIDER’S GOOD 
REPUTATION, IF THE CUSTOMER VIOLATES THE DEMO TRADING 
RULES PURSUANT TO CLAUSE 5.4, IF THE CUSTOMER ACTS IN 
CONFLICT WITH CLAUSE 8.3, AND/OR IF THE CUSTOMER 
PERFORMS ANY OF THE ACTIVITIES REFERRED TO IN CLAUSE 
8.5, THE PROVIDER MAY PREVENT THE CUSTOMER FROM 
ORDERING ANY OTHER SERVICES AND COMPLETELY OR 
PARTIALLY RESTRICT THE CUSTOMER’S ACCESS TO ALL OR 
ONLY SOME SERVICES, INCLUDING ACCESS TO THE CLIENT 
ACCOUNT AND TRADING PLATFORM, WITHOUT ANY PRIOR 
NOTICE AND WITHOUT ANY COMPENSATION. 

12. COMMUNICATION 

12.1. 
You acknowledge that all communication from the Provider or its 
partners in connection with the provision of Services will take place through 
the Client Account or your e-mail address, which you register with us. 
Written electronic communication by e-mail or through the Client Account 
is also considered to be written communication. 

12.2. 
Our contact e-mail address is support@nexxofunded.com and Our contact 
address is Unit 1 74 Back Church Lane, London, E1 1LX UK 

13. RIGHT TO WITHDRAW FROM A CONTRACT 

13.1. 
If you are a consumer, you have the right to withdraw from the GTC 
without giving a reason within 14 days of accepting them. PLEASE NOTE 
THAT IF YOU START PERFORMING DEMO TRADES BEFORE THE 
EXPIRY OF THE SPECIFIED TIME LIMIT, YOU LOSE YOUR RIGHT 
TO WITHDRAW FROM THE GTC. 

13.2. 
Your withdrawal from the GTC must be made via the Trading Platform 
within the specified time limit. We will confirm the receipt of the form to 
you in text form without undue delay. If you withdraw from the GTC, We 
will refund you without undue delay (no later than 30 days after your 
withdrawal from the GTC) all fees We have received from you, in the same 
way in which you paid them. 

13.3. 
The Provider is entitled to withdraw from the GTC in the case of any 
breach by the Customer specified in Clause 11 or if You shall not execute 
any trades within a consecutive period of two (2) months, Your Account shall 
be deemed inactive and will be considered as a breach of the GTC. We 
reserve the right to take appropriate actions regarding inactive accounts, 
which may include, but are not limited to, suspension or termination of GTC. 
The withdrawal from the GTC has effect from the day of its delivery to the 
e-mail address of the Customer or through the Client Account.

14. DEFECTIVE PERFORMANCES 

14.1. 
If the Services do not correspond to what was agreed or have not been 
provided to you, you can exercise your rights from defective performance. 
The Provider does not provide any guarantee for the quality of the services. 
You must notify us of the defect without undue delay at Our e-mail address 
or at Our address listed in clause 11.2. When exercising the rights from 
defective performance, you may request that We remedy the defect or 
provide you with a reasonable discount. If the defect cannot be remedied, you 
can withdraw from the contract or claim a reasonable discount. 

14.2. 
We will try to resolve any complaint you may lodge as soon as possible 
(no later than within 30 calendar days), and We will confirm its receipt and 
settlement to you in writing. If We do not settle the complaint in time, you 
have the right to withdraw from the contract. You can file a complaint by 
sending an e-mail to Our e-mail address support@nexxofunded.com. 

15. CHANGES TO THE GTC 

15.1. 
The Provider reserves the right to change these GTC from time to time 
with effect for the contract previously entered into by the Customer. The 
Provider will notify the Customer of the change in the GTC at least 7 days 
before the change in the GTC is effective, via the Client Account or by e
mail. If the Customer does not agree with the change, the Customer is entitled 
to reject it. The Customer must do so no later than on the last business day 
before these changes take effect by sending the rejection to Our e-mail 
address support@nexxofunded.com. Upon receiving such rejection, the contract will 
be terminated. If the Customer does not reject the change, it is considered 
that the Customer agrees to the new version of GTC. 

15.2. 
If the change offers the Customer a new service or other additional 
functionalities or this change is solely to their advantage, the Provider can 
inform the Customer about this change less than 7 days before the effective 
date of such change, but no later than the day before its effectiveness. 

15.3. 
The Provider will mainly change these GTC for the following reasons: 

15.3.1. 
to introduce new services or products or amend existing services 
or products; 

15.3.2. 
to reflect legal or regulatory requirements that apply to the 
Provider; 

15.3.3. 
when the Provider will try to make these GTC easier to 
understand or more helpful to the Customer; 

15.3.4. 
to adjust the way Our Services are provided, particularly if the 
change is needed because of a change in the way the technology is 
provided or background processes; 

15.3.5. 
to reflect changes in the cost of running Our business. 

16. FINAL PROVISIONS 

16.1. 
16.2. 
The Provider has not adopted any consumers codes of conduct. 
These GTC constitute the complete terms and conditions agreed 
between you and the Provider and supersede all prior agreements relating to 
the subject matter of the GTC, whether verbal or written.

16.3. 
Nothing in these GTC is intended to limit any legal claims set out 
elsewhere in these GTC or arising from the applicable law. If the Provider or 
any third party authorized thereto does not enforce the compliance with these 
GTC, this can in no way be construed as a waiver of any right or claim. 
16.4. 
The Provider may assign any claim arising to the Provider from these 
GTC or any agreement to a third party without your consent. You agree that 
the Provider may, as the assignor, transfer its rights and obligations under 
these GTC or any agreement or parts thereof to a third party. The Customer 
is not authorized to transfer or assign the Customer’s rights and obligations 
under these GTC or any agreements or parts thereof, or any receivables 
arising from them, in whole or in part, to any third party. 

16.5. 
If any provision of the GTC is found to be invalid or ineffective, it shall 
be replaced by a provision whose meaning is as close as possible to the 
invalid provision. The invalidity or ineffectiveness of one provision shall not 
affect the validity of the other provisions. No past or future practice 
established between the parties and no custom maintained in general or in the 
industry relating to the subject-matter of the performance, which is not 
expressly referred to in the GTC, shall be applied and no rights and 
obligations shall be derived from them for the parties; in addition, they shall 
not be taken into account in the interpretation of manifestations of the will of 
the parties. 

16.6. 
The schedules to the GTC form integral parts of the GTC. In the event 
of a conflict between the wording of the main text of the GTC and any 
schedule thereof, the main text of the GTC shall prevail. 

16.7. 
Prior to the mutual acceptance of these GTC, the parties have carefully 
assessed the possible risks arising from them and accept those risks. 

17. DEFINITIONS, EXPRESSIONS AND ABBREVIATIONS USED 

17.1. 
For the purposes of the GTC, the following definitions shall have the 
following meanings: 

17.1.1. 
“Client Account” means the user interface located on the 
Website; 

17.1.2. 
“Content” means the Website and all Services, including the 
Client Section, their appearance and all applications, data, information, 
multimedia elements such as texts, drawings, graphics, design, 
icons, images, audio and video samples and other content that may 
form the Website and the Services (as set out in clause 8.1); 
19.1.3. “Customer” means the user of the Services (as set out in clause 
1.1); 

17.1.3. 
17.1.4. 
“Events” means events as set out in clause 5.4.1; 
“Nexxo Challenge and Verification account” means trading 
accounts related to trading education courses provided as part of the 
Services by the Provider; 

17.1.5. 
“Nexxo Trader account” means a trading account, which relates 
to the Nexxo Trader program provided by a third-party provider; 

17.1.6. 
“Forbidden Trading Practices” means trading practices strictly 
forbidden while using Our Services and are more detailed in Section 
5.4 of these GTC; 

17.1.7. 
“GTC” means these General Terms and Conditions of Nexxo; 

17.1.8. 
“Provider” means the provider of certain Services (as set out 
in clause 1.1); 

17.1.9. 
“Restricted Jurisdictions” are Zimbabwe, Iran, Iraq, North 
Korea, Somalia, Vietnam, Burundi, Central African Republic, Ivory 
Coast, Liberia, Libya, Sudan, Cuba, Syria, Afghanistan, Yemen, 
Palestine, Myanmar, Nicaragua, Congo Republic, Crimea, Democratic 
Republic of Congo, Eritrea, Guinea, Guinea-Bissau, Papua New Guinea, 
South Sudan, Vanuatu, Venezuela, Algeria, Russia, Kenya and Ghana.  

17.1.10. 
“Services” means the Provider’s services as set out in clauses 
1.1 and 1.5; 

17.1.11. 
“Trading Platform” means an electronic interface provided 
by a third party in which the Customer performs the demo trading; 
and 

17.1.12. 
“Website” means the website http://nexxofunded.com/. 

17.2. 
For the purposes of the GTC and their schedules, the following 
expressions and abbreviations shall have the following meanings:

17.2.1. 
“Calendar Day” means the period from midnight to midnight 
of the time currently valid in the UK; 

17.2.2. 
“Initial Capital” means a fictitious amount that the Customer has 
chosen when selecting the option of the Nexxo Challenge and which 
 the Customer will use to perform demo trading; `
              .split('\n\n')
              .map((paragraph, idx) => {
                const trimmed = paragraph.trim();
                const isNumberedTitle = /^\d+\.\s/.test(trimmed);
                const isSubsection = /^\d+\.\d+(?:\.\d+)*\.\s/.test(trimmed);
                const baseClass = 'whitespace-normal';
                const indentClass = isSubsection && !isNumberedTitle ? ' pl-4 md:pl-6' : '';
                return (
                  <p key={idx} className={baseClass + indentClass}>
                    {isNumberedTitle ? <strong>{paragraph}</strong> : paragraph}
                  </p>
                );
              })}
              </div>
        </div>

        {/* Back Button */}
        <div className="text-center mt-12">
          <Link 
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 bg-gray-800 border border-gray-700 rounded-lg text-gray-300 hover:text-white hover:bg-gray-700 transition-colors"
          >
            <ArrowLeft size={16} />
            Back to Website
          </Link>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
